module.exports = __webpack_public_path__ + "static/media/Forestry-Yellow-BG-3rd-Layer-Three@2x.690562f0.png";